import React, {PropsWithChildren, useState} from "react";
import {TransportFormRawValues, TransportFormType} from "../../TransportForm/TransportForm";
import {useTransportForm} from "../../TransportForm/useTransportForm";
import {transportType} from "@ots-frontend/ots-data";
import { TicketFormDefaultValues } from "../TicketForm";

export type TicketFormContextType = {
  pickupForm?: TransportFormType
  pickupValues?: TransportFormRawValues,
  setPickupValues: (values: TransportFormRawValues) => void,
  deliveryForm?: TransportFormType
  deliveryValues?: TransportFormRawValues
  setDeliveryValues: (values: TransportFormRawValues) => void,
  manualLoadedMileage?: number
  manualUnloadedMileage?: number
};

export const TicketFormContext = React.createContext<TicketFormContextType>(undefined!);

export const useTicketForm = (): TicketFormContextType => {
  const context = React.useContext(TicketFormContext);
  if (!context) {
    return {
      pickupForm: undefined,
      pickupValues: undefined,
      setPickupValues: () => undefined,
      deliveryForm: undefined,
      deliveryValues: undefined,
      setDeliveryValues: () => undefined,
    }
  }
  return context
};

export type TicketFormProviderProps = {
  defaultValues?: TicketFormDefaultValues;
  pickupFormRef: (form: TransportFormType) => void
  deliveryFormRef: (form: TransportFormType) => void
}

export function TicketFormProvider(props: PropsWithChildren<TicketFormProviderProps>) {
  const {
    pickupFormRef,
    deliveryFormRef,
    defaultValues,
    children,
  } = props;

  const { form : pickupForm } = useTransportForm({
    type: transportType.pickup,
    defaultValues: defaultValues?.pickup,
  });
  pickupFormRef(pickupForm)

  const { form: deliveryForm} = useTransportForm({
    type: transportType.delivery,
    defaultValues: defaultValues?.delivery,
  });
  deliveryFormRef(deliveryForm)

  const [pickupValues, setPickupValues] = useState<TransportFormRawValues>();
  const [deliveryValues, setDeliveryValues] = useState<TransportFormRawValues>();

  return (
    <TicketFormContext.Provider
      value={{
        pickupForm: pickupForm,
        pickupValues: pickupValues,
        setPickupValues: setPickupValues,
        deliveryForm: deliveryForm,
        deliveryValues: deliveryValues,
        setDeliveryValues: setDeliveryValues,
        manualLoadedMileage: defaultValues?.manualLoadedMileage,
        manualUnloadedMileage: defaultValues?.manualUnloadedMileage,
      }}>
      {children}
    </TicketFormContext.Provider>
  );
}
